import React from 'react'
import { Input, Switch, Select, Divider, Checkbox, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import EditableTable from '../../../../components/EditableTable';
import { cornerOptions, getIBISModelSelectList, getModelSelector, IBISPinAndModelColumns } from '../../../../services/Andes_v2/simulation';
import { numberCheck } from '../../../../services/helper/dataProcess';

/**
 * IBISRender
 * @param {{
 * ibisLibraryList, modelTypeSelectList, modelNameSelectList, selectorModels, model, setModelInfo
 * }} props
 */
class IBISRender extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      IBISPinAndModelColumns: [],
      editPowerOff: {},
      applyAll: false
    }
  }

  getIBISPinAndModelColumns = (paramModel) => {
    const model = paramModel || this.props.model;

    const { pinModels } = model;
    const powerOff = (pinModels[0] || {}).powerOff;
    const _IBISPinAndModelColumns = IBISPinAndModelColumns.filter(item => !['pullUpVoltage', 'pullDownVoltage'].includes(item.key) || powerOff)
    _IBISPinAndModelColumns.forEach((column, index) => {
      if (index === 1) {
        column.onCell = (record) => {
          const { modelNameSelectList } = this.props;
          return {
            record,
            edit: "select",
            options: modelNameSelectList,
            dataIndex: "modelName",
            getPopupContainer: document.getElementById('root'),
            dropdownMenuClassName: "aurora-select-dropdown",
            popupRender: (menu, _record) => this.applyToAllRender(menu, _record),
            handleSave: (record) => this.selectIBISModelInfo('modelName', { modelNameInfo: record }),
            onFocus: () => this.setState({ applyAll: false })
          }
        }
      } else if (index === 2) {
        column.onCell = (record) => {
          return {
            record,
            edit: "select",
            options: cornerOptions,
            dataIndex: "corner",
            getPopupContainer: document.getElementById('root'),
            dropdownMenuClassName: "aurora-select-dropdown",
            handleSave: (record) => this.selectCorner(record),
          }
        }
      } else if (index === 3 || index === 4) {
        column.render = (_, record) => {
          const { editPowerOff } = this.state;
          const { pin } = record;
          const dataIndex = index === 3 ? "pullUpVoltage" : "pullDownVoltage";
          const value = record[dataIndex];
          return <Input
            value={editPowerOff.pin === pin && editPowerOff.dataIndex === dataIndex ? editPowerOff.value : value}
            addonAfter="V"
            onFocus={() => this.focusPowerOffInput({ pin: record.pin, dataIndex, value })}
            onChange={(e) => this.changeEditPowerOff(e.target.value)}
            onBlur={this.savePowerOff}
            onPressEnter={(e) => e.target.blur()}
          />;
        }
      }
    })

    this.setState({ IBISPinAndModelColumns: [..._IBISPinAndModelColumns] })
  }

  selectIBISModelInfo = async (changeType, { libraryId, modelNameInfo, modelType, modelSelector, applyToAll }) => {
    const { applyAll } = this.state;
    const { model, ibisLibraryList, selectorModels: prevSelectorModels, type, modelNameSelectList: prevModelNameSelectList } = this.props
    let _files = [...model.files], _pinModels = [...model.pinModels];
    const file = ibisLibraryList.find(item => item.id === libraryId) || {};
    switch (changeType) {
      case 'libraryId':
        _files[0] = { ..._files[0], libraryId: file.id, fileName: file.name, modelType: "", modelSelector: "" };
        _pinModels = [...model.pinModels].map(item => {
          return { ...item, libraryId: "", fileName: "", modelName: "", modelType: "", enableVoltage: "" };
        })
        break;
      case 'modelType':
        _files[0] = { ..._files[0], modelType };
        break;
      case 'modelSelector':
        _files[0] = { ..._files[0], modelSelector };
        break;
      case 'modelName': // pinModels select modelName backfills modelType and modelSelector
        // modelNameInfo: {pin, net, libraryId, fileName, modelName: 'I/O DQS DQS_34_1066'}
        const modelInfo = prevModelNameSelectList.find(item => item.key === modelNameInfo.modelName) || {};
        const [_modelType, modelName] = modelNameInfo.modelName.split(' ');
        const _modelSelector = getModelSelector(prevSelectorModels, modelName);
        _files[0] = { ..._files[0], modelType: _modelType, modelSelector: _modelSelector };
        _pinModels = [...model.pinModels].map(item => {
          if (item.pin === modelNameInfo.pin || applyToAll || applyAll) {
            return {
              ...item,
              modelName,
              libraryId: _files[0].libraryId,
              fileName: _files[0].fileName,
              modelType: _modelType,
              enableVoltage: modelInfo.enableVoltage
            }
          }
          return item;
        })
        break;
      default:
        break;
    }

    const { modelNameSelectList, modelTypeSelectList, selectorModels } = await getIBISModelSelectList(_files[0], type);

    this.setState({
      IBISPinAndModelColumns
    }, () => {
      this.props.setModelInfo({
        modelNameSelectList,
        modelTypeSelectList,
        selectorModels,
        model: { ...model, files: [..._files], pinModels: [..._pinModels] },
      });

      this.getIBISPinAndModelColumns({ ...model, files: [..._files], pinModels: [..._pinModels] }, modelNameSelectList);
    })
  }

  selectCorner = ({ corner, pin }) => {
    const { model } = this.props;
    const _pinModels = [...model.pinModels].map(item => {
      if (item.pin === pin) {
        return { ...item, corner };
      }
      return item;
    })
    this.props.setModelInfo({ model: { ...model, pinModels: [..._pinModels] } });
  }

  focusPowerOffInput = (data) => {
    this.setState({ editPowerOff: { ...data } })
  }

  changeEditPowerOff = (value) => {
    const { editPowerOff } = this.state;
    this.setState({ editPowerOff: { ...editPowerOff, value } })
  }

  savePowerOff = () => {
    const { model } = this.props;
    const { editPowerOff: { value, dataIndex, pin } } = this.state;
    // check number
    if (!numberCheck(value)) {
      const pinModels = [...model.pinModels];
      const index = pinModels.findIndex(item => item.pin === pin);
      pinModels[index][dataIndex] = value;
      this.props.setModelInfo({ model: { ...model, pinModels } });
    }
    this.setState({ editPowerOff: {} })
  }

  switchPowerOff = (checked) => {
    const { model } = this.props;
    const _pinModels = model.pinModels.map(item => {
      return { ...item, powerOff: checked }
    })
    this.props.setModelInfo({ model: { ...model, pinModels: [..._pinModels] } });
    this.getIBISPinAndModelColumns({ ...model, pinModels: [..._pinModels] });
  }

  changeApplyAll = (e, record) => {
    const checked = e.target.checked;
    this.setState({ applyAll: checked });
    if (checked && record.modelName) {
      this.selectIBISModelInfo('modelName', {
        modelNameInfo: { ...record, modelName: `${record.modelType} ${record.modelName}` },
        applyToAll: checked
      });
    }
  }

  applyToAllRender = (menu, record) => {
    const { applyAll } = this.state;
    return <div>
      {menu}
      <Divider className='andes-v2-sweep-select-dropdown-divider' />
      <div onMouseDown={e => e.preventDefault()} onClick={(e) => e.preventDefault()} className='andes-v2-sweep-apply-all-checkbox'>
        <Checkbox checked={applyAll} onChange={(e) => this.changeApplyAll(e, record)} >
          Apply to all pins
        </Checkbox>
      </div>
    </div>
  }

  render() {
    const { IBISPinAndModelColumns } = this.state;
    const { ibisLibraryList, modelTypeSelectList, selectorModels, model: { files, pinModels = [] } } = this.props;

    const file = files[0] || {};
    let notExist = false;
    const findFile = ibisLibraryList.find(item => item.id === file.libraryId);
    if (file.libraryId && !findFile) {
      notExist = true;
    }
    return (<div>
      {/* Model File */}
      <div className='andes-v2-hspice-simulation-model-row'>
        {/* File - subckt */}
        <span>Model File</span>
        <Select
          allowClear
          value={notExist ? file.fileName : file.libraryId}
          onChange={(value) => this.selectIBISModelInfo('libraryId', { libraryId: value })}
          className='andes-v2-hspice-simulation-model-select ibis-model-file-select'
          popupClassName='aurora-select-dropdown'
          getPopupContainer={() => document.getElementById('root')}
          options={ibisLibraryList.map(item => { return { value: item.id, label: item.name } })}
        />
        {notExist ? <Tooltip
          title="The file was not found, please choose again"
          classNames={{ root: 'aurora-tooltip' }}
        >
          <QuestionCircleOutlined className="andes-v2-hspice-simulation-file-not-exist-icon andes-v2-hspice-simulation-icon" />
        </Tooltip> : null}
      </div>
      {/* Model Type | Model Selector*/}
      <div className='andes-v2-hspice-simulation-model-row'>
        {
          [{ element: 'modelType', label: "Model Type", value: file.modelType, options: modelTypeSelectList },
          { element: "modelSelector", label: "Model Selector", value: file.modelSelector, options: selectorModels }]
            .map((info) => (
              <div className={'andes-v2-hspice-simulation-model-row-item' + (info.element === "modelType" ? " ibis-model-type" : "")} key={info.element}>
                <span>{info.label}</span>
                <Select
                  allowClear
                  value={info.value || ""}
                  onChange={(value) => this.selectIBISModelInfo(info.element, { [info.element]: value })}
                  className='andes-v2-hspice-simulation-model-select'
                  popupClassName='aurora-select-dropdown'
                  getPopupContainer={() => document.getElementById('root')}
                  options={
                    info.element === "modelType"
                      ? modelTypeSelectList.map(item => { return { value: item, label: item } })
                      : selectorModels.map(item => { return { value: item.selector, label: item.selector } })
                  }
                />
              </div>
            ))
        }
      </div>
      {/* Switch PowerOff */}
      <div className='andes-v2-hspice-simulation-flex'>
        <span className='andes-v2-hspice-simulation-title'>Power Off</span>
        <Switch
          size="small"
          className='aurora-switch-small ibis-switch-top-7'
          onChange={this.switchPowerOff}
          checked={(pinModels[0] || {}).powerOff}
        />
      </div>
      {/* Pin - Model */}
      <EditableTable
        rowKey={record => `rx-model-pin-model-${record.pin}`}
        columns={IBISPinAndModelColumns}
        dataSource={pinModels}
        size="small"
        className="rx-model-ibis-table"
      />
    </div>)
  }
}

export default IBISRender;